import { render } from "./NotificationsInbox.vue?vue&type=template&id=2bb0a348&scoped=true"
import script from "./NotificationsInbox.vue?vue&type=script&lang=js"
export * from "./NotificationsInbox.vue?vue&type=script&lang=js"

import "./NotificationsInbox.vue?vue&type=style&index=0&id=2bb0a348&lang=css"
import "./NotificationsInbox.vue?vue&type=style&index=1&id=2bb0a348&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb0a348"]])

export default __exports__